import React from 'react';
import './PageHeader.css';

export default function PageHeader({ title, subtitle, actionButton }) {
    return (
        <div className="page-header">
            <div className="page-header-text">
                <h1>{title}</h1>
                {subtitle && <p className="page-subtitle">{subtitle}</p>}
            </div>
            {actionButton && (
                <div className="page-header-action">
                    {actionButton}
                </div>
            )}
        </div>
    );
}
